import { useDispatch } from 'react-redux';
import { MessageBlock, Input, Modal } from '@monavate/ui-core';
import {
    closeGenerateApiKeyModal,
    generateApiKey,
} from '@/reduxStore/slices/webhookAndApiKeysSlice';
import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { apiKeySchema } from '@/helpers/schemaValidations';

const defaultPApiKeyObject = {
    description: '',
};

interface GenerateApiKeyModalProps {
    isOpen: boolean;
}

const ApiKeyGenerateModal: React.FC<GenerateApiKeyModalProps> = ({ isOpen }) => {
    const dispatch = useDispatch();

    const {
        formState: { errors, isValid },
        register,
        getValues,
    } = useForm({
        resolver: yupResolver(apiKeySchema),
        mode: 'all',
        defaultValues: defaultPApiKeyObject,
    });

    const onCancelButtonClickHandler = () => {
        dispatch(closeGenerateApiKeyModal());
    };
    const onGenerateButtonClickHandler = async () => {
        const values = getValues();
        // @ts-ignore
        dispatch(generateApiKey(values.description.trim()));
    };

    return (
        <Modal
            width={448}
            open={isOpen}
            title="Generate API key"
            onClose={onCancelButtonClickHandler}
            onSubmit={onGenerateButtonClickHandler}
            submitTitle="Generate"
            disabledSubmit={!isValid}
            contentGap={8}
        >
            <MessageBlock styles={{ margin: '0' }} transparent={false}>
                API keys are fully exposed only right after generation.
            </MessageBlock>
            <Input
                style={{ width: '100%', height: '104px' }}
                maxLength={40}
                placeholder={'Text'}
                inputType={'textarea'}
                label="Description"
                required
                symbolCounterLimit={40}
                register={() => register('description')}
                error={errors.description?.message}
            />
        </Modal>
    );
};

export default ApiKeyGenerateModal;
